import * as Yup from 'yup'
import catchApiFailure from '../catch-api-error'
import ApiFactory, { ApiTypes } from '../../index'
import configBuilder from '../config-builder'
import { normalizeJsonToApi } from '../../helpers'

const api = ApiFactory.getApi(ApiTypes.member)

const RequestSchema = Yup.object().shape({
  memberId: Yup.string().required(),
  type: Yup.string().oneOf(['tc-app', 'tc-community-rules', 'tc-post-agreement']).required(),
  version: Yup.string().matches(/^\d+\.\d+\.\d+$/, 'Version must be a valid format'),
})

export const isValid = async (params) => await RequestSchema.isValid(params)
export const validate = async (params) => RequestSchema.validate(params)
export const make = async (params) => {
  const clean = RequestSchema.cast(params)
  delete clean.memberId
  return normalizeJsonToApi(clean)
}
export const url = ({ memberId }) => `/v1/members/${memberId}/terms-conditions`
export const execute = async (params) =>
  api.put(url(params), await make(params), configBuilder(params)).catch(catchApiFailure)
